import React from 'react';
import { useTabContext } from './TabGroup';
import classNames from 'classnames';
import { Typography } from '../Typography';

interface ITab {
  children: React.ReactNode;
  tabId: string;
  className?: string;
}

export const TabButton = ({ children, tabId, className }: ITab) => {
  const { setActiveTabId, activeTabId } = useTabContext();
  return (
    <button
      className={classNames(
        'bg-white p-2 rounded-lg lg:p-[10px]',
        {
          'ring-2 ring-primary-500': activeTabId === tabId,
        },
        className
      )}
      onClick={() => setActiveTabId(tabId)}
    >
      <Typography
        component="span"
        variant="bodyXL"
        className={classNames(
          'text-neutral-500 whitespace-nowrap',

          className
        )}
      >
        {children}
      </Typography>
    </button>
  );
};

export const Tab = ({ children, tabId }: ITab) => {
  const { activeTabId } = useTabContext();

  if (activeTabId !== tabId) return null;
  return <div className="w-full">{children}</div>;
};
